export const SEND_CONTACTS_REQUEST_START = 'SEND_CONTACTS_REQUEST_START';
export const SEND_CONTACTS_REQUEST_SUCCESS = 'SEND_CONTACTS_REQUEST_SUCCESS';
export const SEND_CONTACTS_REQUEST_FAILURE = 'SEND_CONTACTS_REQUEST_FAILURE';
